var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsis",style:(`height: ${_vm.size}px; width: ${_vm.size * 6}px`)},[_c('div',{style:(_vm.getStyle())}),_c('div',{style:(_vm.getStyle())}),_c('div',{style:(_vm.getStyle())}),_c('div',{style:(_vm.getStyle())})])
}
var staticRenderFns = []

export { render, staticRenderFns }